<template>
    <v-card-actions
        class="plot-footer"
        :class="{
            'absolute-layout': absoluteLayoutType.includes(type),
            'justify-center': type === 'plot-grid'
        }"
    >
        <v-btn
            id="gtm-plotcard-cta-discover"
            outlined
            small
            rounded
            class="habiteo-btn promoter-customization text-capitalize"
            :class="{ 'mr-4': $vuetify.breakpoint.mdAndUp }"
            @click.prevent="updateWidget(data)"
        >
            {{ $t('widgets.plot.discover') }}
        </v-btn>
    </v-card-actions>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'PlotFooter',
        props: {
            data: {
                type: Object,
                required: true
            },
            type: {
                type: String,
                required: true
            }
        },
        data: () => ({
            absoluteLayoutType: [
                'plot'
            ]
        }),
        computed: {
            externalLink() {
                if (!this.data.details) return null;
                const externalLinkDetail = this.data.details.find(detail => detail.id === 'external_link');
                return externalLinkDetail ? externalLinkDetail.value : null;
            }
        },
        methods: {
            updateWidget(plot) {
                if (this.externalLink) {
                    EventBus.$emit('openExternalLink', this.externalLink);
                    return;
                }
                this.$emit('update-widget', plot);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .plot-footer {
        &.absolute-layout {
            position: absolute;
            bottom: 5px;
            right: 0px;
            height:36px;
        }
    }
    .habiteo-btn {
        height: 34px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/plotInformation/layout/PlotFooter.vue